/* Opportunity decisions store (W1-D). accept/defer/dismiss keyed to the stable
 * opportunity key (opp:{action}:{slug}); the actor comes from the session on the
 * server, never the body. Accepting NEVER creates a task. */
import { request } from './client.ts';

export type DecisionVerb = 'accepted' | 'deferred' | 'dismissed';

export interface Decision {
  client_slug: string;
  opportunity_key: string;
  decision: DecisionVerb;
  actor: string | null;
  actor_user_id: number | null;
  note: string | null;
  decided_at: string;
}

/** GET /clients/{slug}/decisions — every recorded decision for the client. */
export function getDecisions(slug: string): Promise<Decision[]> {
  return request<{ decisions?: Decision[] }>(`/clients/${slug}/decisions`).then(
    (r) => r.decisions || [],
  );
}

/** POST /clients/{slug}/decisions — record/change one opportunity's decision. */
export function setDecision(
  slug: string,
  opportunityKey: string,
  decision: DecisionVerb,
  note?: string | null,
): Promise<Decision> {
  return request<{ decision: Decision }>(`/clients/${slug}/decisions`, {
    method: 'POST',
    body: JSON.stringify({ opportunityKey, decision, note: note ?? null }),
  }).then((r) => r.decision);
}
